export const LANDING_PAGE_URL = 'https://www.angellira.com.br';
